// A copy of the default student messages
import { teacherMessages } from './en-US.js';

export const programId = '5d4074dba6a80f2081357fd1';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    useFingerprinting: 'true',
    logLevel: 'error',
    messagesWithLocale: {
        'en-US': teacherMessages,
    },
};
